import styled from 'styled-components';
import {Button as StyledButton, Button2} from '../../styles/buttons';

// ========== COMPONENTES COMPARTILHADOS ==========
export const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1a4d2e 0%, #0f2818 100%);
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Container alternativo sem background gradiente (para histórico)
export const ContainerLight = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LogoContainer = styled.div`
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Logo = styled.img`
  max-width: 200px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));

  @media (max-width: 600px) {
    max-width: 150px;
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h1 {
    color: #d4af37;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 10px;
  }
`;

// Header alternativo para páginas claras
export const HeaderLight = styled.div`
  text-align: center;
  margin-bottom: 40px;
  width: 100%;
  max-width: 1000px;

  h1 {
    color: #1a4d2e;
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 10px;
    padding-bottom: 15px;
    border-bottom: 3px solid #d4af37;
  }
`;

export const Description = styled.p`
  color: #e0e0e0;
  font-size: 20px;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 40px;
  line-height: 1.6;
`;

export const ContractsContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const ContractCard = styled.div<{ $isAccepted: boolean }>`
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  border: 3px solid ${props => props.$isAccepted ? '#d4af37' : 'transparent'};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2);
  }
`;

export const ContractTitle = styled.h2`
  color: #1a4d2e;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #d4af37;
`;

export const PdfContainer = styled.div`
  margin: 20px 0;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
`;

export const PdfIframe = styled.iframe`
  border: none;
  display: block;
`;

export const ErrorContainer = styled.div`
  padding: 60px 40px;
  text-align: center;
  background: linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%);

  p {
    color: #d32f2f;
    font-size: 16px;
    font-weight: 500;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f0f0;
    border-color: #d4af37;
  }
`;

export const CheckboxInput = styled.input`
  width: 24px;
  height: 24px;
  cursor: pointer;
  accent-color: #1a4d2e;

  &:checked {
    accent-color: #d4af37;
  }
`;

export const CheckboxLabel = styled.label`
  color: #333;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
`;

export const ProgressText = styled.p`
  color: #d4af37;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 30px 0 20px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 10px;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1000px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const BaseButton = styled.button`
  padding: 16px 40px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-width: 200px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const RejectButton = styled(BaseButton)`
  background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);
  color: white;

  &:hover {
    background: linear-gradient(135deg, #c62828 0%, #b71c1c 100%);
  }
`;

export const DoubtsButton = styled(BaseButton)`
  background: transparent;
  color: #a0a0a0;
  border: 1px solid #a0a0a0;
  font-size: 14px;
  font-weight: 400;
  padding: 10px 24px;
  min-width: unset;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
    color: #c0c0c0;
    border-color: #c0c0c0;
    box-shadow: none;
    transform: none;
  }
`;

export const ContinueButton = styled(BaseButton)`
  background: linear-gradient(135deg, #1a4d2e 0%, #0f2818 100%);
  color: #d4af37;
  border: 2px solid #d4af37;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #0f2818 0%, #051108 100%);
    box-shadow: 0 4px 12px rgba(212, 175, 55, 0.3);
  }

  &:disabled {
    background: #ccc;
    border-color: #999;
    color: #666;
  }
`;

// ========== HISTÓRICO DE CONTRATOS ==========
export const HistoryContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

export const HistoryCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border-left: 4px solid #d4af37;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    border-left-width: 6px;
  }
`;

export const HistoryCardTitle = styled.h3`
  color: #1a4d2e;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
`;

export const ContractInfo = styled.div`
  color: #666;
  font-size: 15px;
  line-height: 1.8;
  margin-bottom: 20px;

  p {
    margin-bottom: 8px;
  }

  strong {
    color: #1a4d2e;
    font-weight: 600;
  }
`;

export const DownloadButton = styled(BaseButton)<{ $isDownloading: boolean }>`
  background: ${props => props.$isDownloading
  ? 'linear-gradient(135deg, #9e9e9e 0%, #757575 100%)'
  : 'linear-gradient(135deg, #d4af37 0%, #c5a028 100%)'};
  color: ${props => props.$isDownloading ? '#e0e0e0' : '#1a4d2e'};
  cursor: ${props => props.$isDownloading ? 'not-allowed' : 'pointer'};
  min-width: 250px;
  font-size: 16px;
  padding: 14px 32px;

  &:hover:not(:disabled) {
    background: ${props => props.$isDownloading
  ? 'linear-gradient(135deg, #9e9e9e 0%, #757575 100%)'
  : 'linear-gradient(135deg, #c5a028 0%, #b69120 100%)'};
    transform: ${props => props.$isDownloading ? 'none' : 'translateY(-2px)'};
  }
`;

export const EmptyState = styled.div`
  width: 100%;
  max-width: 1000px;
  background: #ffffff;
  border-radius: 12px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  p {
    color: #666;
    font-size: 18px;
    line-height: 1.6;
  }

  svg, span {
    font-size: 48px;
    color: #d4af37;
    margin-bottom: 20px;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  align-items: center;
`;

export const FilterInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  flex: 1;
  max-width: 300px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: rgb(15, 44, 40);
  }
`;

export const FilterButton = styled(Button2)`
  margin: 0;
  max-width: 200px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 30px;
  margin-bottom: 20px;
`;

export const PaginationButton = styled(StyledButton)<{ disabled?: boolean }>`
  margin: 0;
  padding: 10px 20px 32px 20px;
  border: none;
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:active:not(:disabled) {
    opacity: 0.8;
  }
`;

export const PageInfo = styled.span`
  font-weight: bold;
  font-size: 14px;
`;
